// Generated by scripts/theme-config/theme-config.js from api::theme-configuration. Do not edit.

/**
 * Knobs build-time del listado (Algolia hits) que no son CSS. Vienen de
 * ThemeConfiguration via `npm run themeconfig` — refleja cualquier
 * cambio sólo tras regenerar.
 */
export type GeneratedListingConfig = {
  hitsPerPage: number;
  viewBarAlign: 'spaceBetween' | 'end';
  showSort: boolean;
  mobileFiltersModal: boolean;
  filtersGrid: boolean;
  customViewGridIcon: boolean;
  customViewListIcon: boolean;
  viviendaPageStyle: 'legacy' | 'hero';
};

export const generatedListingConfig: GeneratedListingConfig = {
  "hitsPerPage": 8,
  "viewBarAlign": "spaceBetween",
  "showSort": false,
  "mobileFiltersModal": false,
  "filtersGrid": false,
  "customViewGridIcon": false,
  "customViewListIcon": false,
  "viviendaPageStyle": "legacy"
};
